import { BordOneToneIcon } from 'components/NudosComponents';
import { TbordOneToneIcon } from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon.types';
import { TOOL_STATUS_NAME } from 'types/tools';
import './EditableButton.scss';

export const EditableButton = ({
  titleButton,
  showIcon,
  onClick,
  variantIcon,
  colorIcon,
  isDisabled,
  isAvailableClass
}: IEditableButtonProps) => {
  const isAvailable = titleButton === TOOL_STATUS_NAME.AVAILABLE;
  const renderAvailableClass = isAvailable ? 'availiable' : 'unavailiable';
  return (
    <div className={`editableButtton ${isDisabled ? 'disabled' : ''} ${isAvailableClass ? renderAvailableClass : ''}`} onClick={isDisabled ? undefined : onClick}>
     {isAvailableClass && <div className={`circle ${renderAvailableClass}`} />}
      {titleButton}
      {showIcon && <BordOneToneIcon variant={variantIcon} customWidth="14px" stroke={colorIcon} />}
    </div>
  );
};

interface IEditableButtonProps {
  titleButton: string;
  showIcon: boolean;
  onClick: () => void;
  variantIcon: TbordOneToneIcon;
  colorIcon: string;
  isDisabled?: boolean;
  isAvailableClass?: boolean;
}
